import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Notification from 'utils/Notifications'

import styles from './../RaportForm.module.scss'

import { getEmployee } from 'service/TaskService'
import { setEmployee } from 'store/slices/TaskSlice'

import { Button } from 'components'
import TaskResponsible from 'components/Forms/TaskForm/components/TaskResponsible/TaskResponsible'
const AgreementForm = ({ setRender, setState }) => {
  const { t } = useTranslation('common')
  const [Responsible, setResponsible] = useState([])
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()

  const getData = async () => {
    try {
      let response = await getEmployee(data)

      dispatch(
        setEmployee({
          employee: response.data,
        }),
      )
    } catch (error) {
    }
  }

  useEffect(() => {
    getData()
  }, [])


  const employee = useSelector((state) => state.task)
  const data = [employee.employee]
  return (
    <div className={styles.wrapper}>
      <div className={styles.signer}>
        <TaskResponsible
          dataResponsible={data}
          setResponsible={setResponsible}
          IsMilti={false}
          text={t('forms.agreementForm.to_label')}
        />
      </div>

      <div className={styles.statement_footer}>
        <Button className={styles.btn1}>{t('common.submit')}</Button>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default AgreementForm
